import React from 'react'
import { SlEarphonesAlt } from "react-icons/sl";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { MdOutlineWatchLater } from "react-icons/md";
import { GrUserExpert } from "react-icons/gr";
import serviceImage from "../assets/24hs.jpg";

const WhyUs = () => {
  return (
    <div>
        
        <div className="max-w-4xl m-auto mt-16">
          <div className="text-center m-8">
              <h2 className="font-semibold text-4xl">Why choose us?</h2>
              <p className="w-md mx-auto mt-2 text-gray-700">When it comes to selecting an insurance provider, the choices can be overwhelming. However, choosing the right company is crucial for ensuring that you receive the best coverage and service tailored to your needs. Here are several compelling reasons why you should choose us as your insurance partner.</p>
          </div>
      
      
          <div className="text-gray-700 body-font">
        <div className="container px-5 py-10 m-auto">
          <div className="flex flex-wrap text-center justify-center">
            <div className="p-4 md:w-1/5 sm:w-1/4">
              <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div className="flex justify-center">
                  <SlEarphonesAlt size={80}/>
                </div>
                <h2 className="title-font font-regular text-lg text-gray-900">Customer-Centric Approach</h2>
              </div>
            </div>
      
            <div className="p-4 md:w-1/5 sm:w-1/4">
              <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div className="flex justify-center">
                  <FaHandHoldingDollar size={80} className=''/>
                </div>
                <h2 className="title-font font-regular text-lg text-gray-900">Reasonable Prices</h2>
              </div>
            </div>
      
            <div className="p-4 md:w-1/5 sm:w-1/4">
              <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div className="flex justify-center">
                  <MdOutlineWatchLater size={80}/>
                </div>
                <h2 className="title-font font-regular text-lg text-gray-900">Time Efficiency</h2>
              </div>
            </div>
      
            <div className="p-4 md:w-1/5 sm:w-1/4">
              <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div className="flex justify-center">
                  <GrUserExpert size={80}/>
                </div>
                <h2 className="title-font font-regular text-lg text-gray-900">Expertise in Industry</h2>
              </div>
            </div>

            <div className="p-4 md:w-1/5 sm:w-1/2">
              <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div className="flex justify-center">
                  <img src={serviceImage} alt="ServiceImage" width={120}/>
                </div>
                <h2 className="title-font font-regular text-lg text-gray-900">24/7 Services</h2>
              </div>
            </div>
      
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default WhyUs
